import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

/**
 * Search box above a DataTable. Controlled; pair with useDataTable's `searchInput` /
 * `handleSearchChange` (the hook debounces before it touches the URL).
 */
const TableSearch = ({ value, onChange, placeholder, sx }) => (
  <TextField
    fullWidth
    placeholder={placeholder}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      ),
    }}
    sx={sx}
  />
);

export default TableSearch;
